import { Controller, useFormContext } from 'react-hook-form';

import type { CustomisedToggleProps } from '@polyai/ui/components/atoms/Toggle';
import Toggle from '@polyai/ui/components/atoms/Toggle';

import type { SharedFormProps } from './types';

type Props<T> = SharedFormProps<T> & Omit<CustomisedToggleProps, 'toggleOn'>;

export const FormToggle = <T,>({
  controlKey,
  handleToggle,
  ...rest
}: Props<T>) => {
  const { control } = useFormContext();

  return (
    <Controller
      control={control}
      name={controlKey as string}
      render={({ field }) => (
        <Toggle
          handleToggle={() => {
            field.onChange(!field.value);
            handleToggle?.(!field.value);
          }}
          {...rest}
          toggleOn={field.value}
        />
      )}
    />
  );
};
